import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { colorClassNames } from 'lib/settings';

const Responsibility = props => {
	const {
		t,
		componentData,
		options,
		building,
		language
	} = props;

	const backgroundColor = options['background-color'];
	const bgColorClass = backgroundColor in colorClassNames ? colorClassNames[backgroundColor] : '';

	let componentClass = 'b-component b-responsibility';

	if (bgColorClass) {
		componentClass += ' b-slot-theme-' + bgColorClass;
	}

	const style = {
		backgroundColor,
	};

	const responsibilities = (componentData.items || []).filter(id => !!props.responsibilities.find(item => item.id === id)).map(id => {
		const responsibility = props.responsibilities.find(item => item.id === id);
		return {
			id: id,
			title: building.i18n[language][`responsibility_${responsibility.id}_title`] || responsibility.i18n[language].name,
			icon: responsibility.iconUrl,
			description: building.i18n[language][`responsibility_${responsibility.id}`] || ''
		};
	});

	const logos = (componentData.logos || []).filter(id => props.certificates.find(item => item.id === id)).map(id => {
		return props.certificates.find(item => item.id === id);
	});

	const images = (componentData.images || []).map(file => {
		const img = building.images.find(item => item.file === file);
		if (!img) {
			return false;
		}
		return { id: img.file, url: img.conversions.large };
	}).filter(img => !!img);

	const sidebarContent = building.i18n[language].responsibility_additional_value;

	return (
		<div className={componentClass} style={style}>
			<div className={'b-responsibility-content' + (componentData.sidebar === 'none' ? ' full-width' : '')}>
				<h1>{t('responsibility/Page title')}</h1>
				<div className="b-responsibility-logos">
					{logos.map(logo => {
						return (
							<div key={logo.id} className={'b-responsibility-logo ' + logo.id}>
								<img src={logo.logoUrl} alt={''} />
							</div>
						)
					})}
				</div>
				<div className={'b-responsibility-items columns-' + (componentData.columns || 3)}>

					{responsibilities.map(responsibility => {
						return (
							<div key={responsibility.id} className="b-responsibility-item">
								<div className="b-responsibility-item-header">
									<div className="b-responsibility-item-icon"><img src={responsibility.icon} alt={''} /></div>
									<div className="b-responsibility-item-title">{responsibility.title}</div>
								</div>
								<div className="b-responsibility-item-content" dangerouslySetInnerHTML={{__html: responsibility.description}}></div>
							</div>
						)
					})}
				</div>
			</div>
			{componentData.sidebar !== 'none' && (
				<div className={'b-responsibility-sidebar' + (componentData.sidebar === 'image' ? ' bg-image' : '')}>
					{componentData.sidebar === 'text' && (
						<div className="b-responsibility-sidebar-content" dangerouslySetInnerHTML={{__html: sidebarContent}}></div>
					)}
					{componentData.sidebar === 'image' && images.map(img => (
						<div key={img.id} className="b-responsibility-sidebar-image" style={{ backgroundImage: 'url(' + img.url + ')' }}></div>
					))}
				</div>
			)}
		</div>
	);
}

Responsibility.propTypes = {
	t: PropTypes.func,
	language: PropTypes.oneOf(['fi', 'en']),
	componentData: PropTypes.object,
	options: PropTypes.object,
	building: PropTypes.object,
	slotActive: PropTypes.bool,
}

export default translate('translations')(Responsibility);
